
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { ArrowDown } from "../../../../assets/icons";
import EpisodeAction from "./EpisodeAction";

const Episode = forwardRef(({ episode, isOwner, index, onReloadNeeded, onOpen }, ref) => {
	const videoRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);
	const [isPlaying, setIsPlaying] = useState(false);

	useImperativeHandle(ref, () => ({
		close() {
			if (videoRef.current) {
				videoRef.current.pause();
			}
			setIsOpen(false);
			setIsPlaying(false);
		}
	}));

	const handleOpen = () => {
		let currentIsOpen = isOpen;
		setIsOpen(!isOpen);
		if (!currentIsOpen) {
			onOpen();
		}
	}

	return (
		<div className="overflow-hidden rounded-[14px] border border-darkBlue/10 bg-white p-4 shadow-[0_4px_14px_rgba(39,106,166,0.06)]">
			<div className="flex flex-row justify-between items-center cursor-pointer" onClick={handleOpen}>
				<div className="flex flex-row items-center min-w-0">
					<span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px] bg-lightCta font-Vazir-700 text-[13px] text-darkBlue" dir="ltr">
						{index + 1}
					</span>
					<div className="spacer p-[10px]"></div>
					<div className="font-Vazir-600 text-[15px] text-darkBlue truncate">{episode.title}</div>
				</div>
				<div>
					<ArrowDown />
				</div>
			</div>
			<div className={`${isOpen ? 'max-h-[1800px]' : 'max-h-[0px]'} w-full overflow-hidden transition-all duration-300`}>
				{isOwner && (
					<>
						<EpisodeAction episode={episode} onReloadNeeded={onReloadNeeded} />
						<div className="spacer p-[10px]"></div>
					</>
				)}
				<div className="spacer p-[10px]"></div>
				{episode.has_access ? (
					<>
						{isPlaying ? (
							<video ref={videoRef} src={episode.video_url} className="w-full rounded-[10px]" controls controlsList="nodownload" />
						) : (
							<>
								<div className="relative hover:cursor-pointer" onClick={() => setIsPlaying(true)}>
									<img src={episode.image_url} alt="" className="w-full min-h-[200px] rounded-[10px]" />
									<div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center rounded-[10px]">
										<svg width="40" height="41" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												d="M0.606445 10.6394L0.606445 6.46239C0.606445 1.27633 4.27893 -0.847371 8.77273 1.74566L12.3983 3.83416L16.0238 5.92267C20.5176 8.5157 20.5176 12.7631 16.0238 15.3561L12.3983 17.4446L8.77273 19.5331C4.27893 22.1262 0.606445 20.0025 0.606445 14.8164L0.606445 10.6394Z"
												fill="#FF6A4B"
											/>
										</svg>
									</div>
								</div>
							</>
						)}
					</>
				) : (
					<>
						<div className="font-Vazir-700 text-[16px] text-[#666666]">
							برای تماشای قسمت های کارگاه باید کارگاه را بخرید
						</div>
					</>
				)}
			</div>
		</div>
	)
})

export default Episode;
